export default class SelectionProviderInfoModel {
  public selectionId: string = null;
  public eventId: string = null;
  public marketId: string = null;
  public competitionId: string = null;
}
